import { render, staticRenderFns } from "./FastFacts.vue?vue&type=template&id=fff5fa36&"
import script from "./FastFacts.vue?vue&type=script&lang=js&"
export * from "./FastFacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports